// @ts-check

/**
 * Defines the query keys for retrieving current user preview key.
 */
export const authKeys = {
  /**
   * Represents all user query keys.
   *
   * @type {['user']}
   */
  user: ['user'],
  /**
   * Gets the user query key for retrieving preview key.
   *
   * @returns {['user', 'previewKey']}
   */
  previewKey: () => [...authKeys.user, 'previewKey'],
};
